<template>
  <div class="col-xs-12 col-md-4 col-lg-4 text-center">
    <router-link
        class="btn btn-primary btn-lg"
        :to="{name:'shop-home'}">
      Shop Online Now
      <i class="fa fa-shopping-cart"></i>
    </router-link>
    <h3>Shop Location</h3>
    <address>
      <div itemprop="affiliation" title="Organization" itemscope itemtype="http://schema.org/Organization">
        <h4>
          <span class="organization-name fn" itemprop="name"> <strong>Grotec UK Ltd.</strong> </span>
        </h4>
        <div class="adr" itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
          <span class="street-address" itemprop="streetAddress">
            393 Manchester Road
          </span>,
          <br/>
          <span class="locality" itemprop="addressLocality">Rochdale</span>,<br/> <abbr class="region"
                                                                                      itemprop="addressRegion"
                                                                                      title="Greater Manchester">Gtr
          Manchester, UK</abbr><br/> <abbr class="postal-code" itemprop="postalCode" title="OL11 3PG">OL11
          3PG</abbr><br/>
          <div class="hidden"><span itemscope itemtype="http://schema.org/Place"> <div itemprop="geo"> <span
              itemscope itemtype="http://schema.org/GeoCoordinates"> <span itemprop="latitude"
                                                                           content="53.6032501"></span> <span
              itemprop="longitude" content="-2.1750143"></span> </span> </div> </span></div>
        </div>
      </div>
    </address>
    <router-link :to="{name:'contact'}" title="Location">For maps and directions click here</router-link>
  </div>
</template>
<script>
export default {
  name: 'location-box',
}
</script>